/* import __COLOCATED_TEMPLATE__ from './composer-fullscreen-prompt.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./composer-fullscreen-prompt.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());